module.exports = __webpack_public_path__ + "img/wheat_ns11147.e3b8b0c1.jpg";